<template>
  <el-container>
    <el-header class="table-header">
      <el-button align="center" @click="search('refresh')" size="small">{{
        $t("common.Search")
      }}</el-button>
      <el-button @click="reset" align="center" size="small">刷新</el-button>
    </el-header>
    <el-main class="table-main no-overflow">
      <el-form :model="form" label-width="80px" size="mini" class="table-form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="标题">
              <el-input
                v-model="form.title"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发布人">
              <el-input
                v-model="form.stockInNo"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="发布时间">
              <el-input
                v-model="form.stockInNo"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="dataList"
        ref="dataList"
        border
        highlight-current-row
        stripe
        style="width: 100%"
      >
        <el-table-column label="公告标题">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'viewInStock',
                params: { row: scope.row },
              }"
              >{{ scope.row.title }}</router-link
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="author"
          label="发布人"
        ></el-table-column>
        <el-table-column
          prop="publishTime"
          label="发布时间"
          align="center"
          :formatter="changeTime"
        ></el-table-column>
      </el-table>
      <!-- </div> -->
      <el-footer class="table-footer" style="float: right;">
        <table-page
          ref="stockInListPage"
          :url="stockInListUrl"
          :form="form"
          @page-change="convert"
        ></table-page>
      </el-footer>
    </el-main>
  </el-container>
</template>

<script>
import TablePage from "@/components/TablePage";
import moment from "moment";

export default {
  name: "noticeList",
  data() {
    return {
      form: {},
      stockInListUrl: this.global.BASE_INFO+'/article/findWebArticle',
      dataList: []
    };
  },
  computed: {
  },
  components: {
    TablePage,
  },
  activated() {
    this.search;
  },
  methods: {
    reset() {
      this.form = {};
      this.$nextTick(() => {
        this.search();
      });
    },
    search(param) {
      this.form.beginDay = "";
      this.form.endDay = "";
      if (this.form.date) {
        this.form.beginDay = this.form.date[0];
        this.form.endDay = this.form.date[1];
      }
      this.$refs["stockInListPage"].getTableData(param);
    },
    convert(tableData) {
      this.dataList = tableData.data;
    },
    changeTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  max-height: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/main/components/newsList.vue